/* tslint:disable */
/* eslint-disable */
/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { SafetyChecklistActionCommand } from '../models';
import { SafetyChecklistAdminDashboardResponse } from '../models';
import { SafetyChecklistAttachmentDeleteCommand } from '../models';
import { SafetyChecklistAttachmentUploadCommand } from '../models';
import { SafetyChecklistAttachmentsResponse } from '../models';
import { SafetyChecklistChecklistResponse } from '../models';
import { SafetyChecklistCommentCommand } from '../models';
import { SafetyChecklistCommentQueryResponse } from '../models';
import { SafetyChecklistEditQueryResponse } from '../models';
import { SafetyChecklistSubmitCommand } from '../models';
import { SafetyChecklistTemplateResponse } from '../models';
import { SafetyChecklistTemplatesResponse } from '../models';
import { SafetyChecklistUserDashboardResponse } from '../models';
import { SharedModelsCommandResponse } from '../models';
/**
 * SafetyChecklistApi - axios parameter creator
 * @export
 */
export const SafetyChecklistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SafetyChecklistActionCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistActionPost: async (body?: SafetyChecklistActionCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [managePage] 
         * @param {number} [completedPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAdmindashboardGet: async (toDoPage?: number, overduePage?: number, managePage?: number, completedPage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/admindashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (toDoPage !== undefined) {
                localVarQueryParameter['ToDoPage'] = toDoPage;
            }

            if (overduePage !== undefined) {
                localVarQueryParameter['OverduePage'] = overduePage;
            }

            if (managePage !== undefined) {
                localVarQueryParameter['ManagePage'] = managePage;
            }

            if (completedPage !== undefined) {
                localVarQueryParameter['CompletedPage'] = completedPage;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAllassetsGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/allassets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAssetGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/asset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentDeleteCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentdeletePost: async (body?: SafetyChecklistAttachmentDeleteCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/attachmentdelete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentsGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/attachments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentUploadCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentuploadPost: async (body?: SafetyChecklistAttachmentUploadCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/attachmentupload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistChecklistGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/checklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistCommentGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SafetyChecklistCommentCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistCommentPost: async (body?: SafetyChecklistCommentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [checklistId] 
         * @param {string} [checklistTemplateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistEditGet: async (checklistId?: string, checklistTemplateId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (checklistId !== undefined) {
                localVarQueryParameter['ChecklistId'] = checklistId;
            }

            if (checklistTemplateId !== undefined) {
                localVarQueryParameter['ChecklistTemplateId'] = checklistTemplateId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SafetyChecklistSubmitCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistSubmitPost: async (body?: SafetyChecklistSubmitCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistSummarypdfassetGet: async (id?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/summarypdfasset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistTemplateGet: async (templateId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (templateId !== undefined) {
                localVarQueryParameter['TemplateId'] = templateId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistTemplatesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [completedPage] 
         * @param {number} [managePage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistUserdashboardGet: async (toDoPage?: number, overduePage?: number, completedPage?: number, managePage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/safetychecklist/userdashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (toDoPage !== undefined) {
                localVarQueryParameter['ToDoPage'] = toDoPage;
            }

            if (overduePage !== undefined) {
                localVarQueryParameter['OverduePage'] = overduePage;
            }

            if (completedPage !== undefined) {
                localVarQueryParameter['CompletedPage'] = completedPage;
            }

            if (managePage !== undefined) {
                localVarQueryParameter['ManagePage'] = managePage;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyChecklistApi - functional programming interface
 * @export
 */
export const SafetyChecklistApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SafetyChecklistActionCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistActionPost(body?: SafetyChecklistActionCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistActionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [managePage] 
         * @param {number} [completedPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAdmindashboardGet(toDoPage?: number, overduePage?: number, managePage?: number, completedPage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistAdminDashboardResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAdmindashboardGet(toDoPage, overduePage, managePage, completedPage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAllassetsGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAllassetsGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAssetGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAssetGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentDeleteCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAttachmentdeletePost(body?: SafetyChecklistAttachmentDeleteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAttachmentdeletePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAttachmentsGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistAttachmentsResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAttachmentsGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentUploadCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistAttachmentuploadPost(body?: SafetyChecklistAttachmentUploadCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistAttachmentuploadPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistChecklistGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistChecklistResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistChecklistGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistCommentGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistCommentQueryResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistCommentGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SafetyChecklistCommentCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistCommentPost(body?: SafetyChecklistCommentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistCommentPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [checklistId] 
         * @param {string} [checklistTemplateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistEditGet(checklistId?: string, checklistTemplateId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistEditQueryResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistEditGet(checklistId, checklistTemplateId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SafetyChecklistSubmitCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistSubmitPost(body?: SafetyChecklistSubmitCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistSubmitPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistSummarypdfassetGet(id?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistSummarypdfassetGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistTemplateGet(templateId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistTemplateResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistTemplateGet(templateId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistTemplatesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistTemplatesResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistTemplatesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [completedPage] 
         * @param {number} [managePage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSafetychecklistUserdashboardGet(toDoPage?: number, overduePage?: number, completedPage?: number, managePage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyChecklistUserDashboardResponse>> {
            const localVarAxiosArgs = await SafetyChecklistApiAxiosParamCreator(configuration).apiSafetychecklistUserdashboardGet(toDoPage, overduePage, completedPage, managePage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SafetyChecklistApi - factory interface
 * @export
 */
export const SafetyChecklistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {SafetyChecklistActionCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistActionPost(body?: SafetyChecklistActionCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistActionPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [managePage] 
         * @param {number} [completedPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAdmindashboardGet(toDoPage?: number, overduePage?: number, managePage?: number, completedPage?: number, options?: any): AxiosPromise<SafetyChecklistAdminDashboardResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAdmindashboardGet(toDoPage, overduePage, managePage, completedPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAllassetsGet(id?: string, options?: any): AxiosPromise<void> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAllassetsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAssetGet(id?: string, options?: any): AxiosPromise<void> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAssetGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentDeleteCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentdeletePost(body?: SafetyChecklistAttachmentDeleteCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAttachmentdeletePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentsGet(id?: string, options?: any): AxiosPromise<SafetyChecklistAttachmentsResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAttachmentsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SafetyChecklistAttachmentUploadCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistAttachmentuploadPost(body?: SafetyChecklistAttachmentUploadCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistAttachmentuploadPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistChecklistGet(id?: string, options?: any): AxiosPromise<SafetyChecklistChecklistResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistChecklistGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistCommentGet(id?: string, options?: any): AxiosPromise<SafetyChecklistCommentQueryResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistCommentGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SafetyChecklistCommentCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistCommentPost(body?: SafetyChecklistCommentCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistCommentPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [checklistId] 
         * @param {string} [checklistTemplateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistEditGet(checklistId?: string, checklistTemplateId?: string, options?: any): AxiosPromise<SafetyChecklistEditQueryResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistEditGet(checklistId, checklistTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SafetyChecklistSubmitCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistSubmitPost(body?: SafetyChecklistSubmitCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistSubmitPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistSummarypdfassetGet(id?: string, options?: any): AxiosPromise<void> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistSummarypdfassetGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [templateId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistTemplateGet(templateId?: string, options?: any): AxiosPromise<SafetyChecklistTemplateResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistTemplateGet(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistTemplatesGet(options?: any): AxiosPromise<SafetyChecklistTemplatesResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [toDoPage] 
         * @param {number} [overduePage] 
         * @param {number} [completedPage] 
         * @param {number} [managePage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSafetychecklistUserdashboardGet(toDoPage?: number, overduePage?: number, completedPage?: number, managePage?: number, options?: any): AxiosPromise<SafetyChecklistUserDashboardResponse> {
            return SafetyChecklistApiFp(configuration).apiSafetychecklistUserdashboardGet(toDoPage, overduePage, completedPage, managePage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyChecklistApi - object-oriented interface
 * @export
 * @class SafetyChecklistApi
 * @extends {BaseAPI}
 */
export class SafetyChecklistApi extends BaseAPI {
    /**
     * 
     * @param {SafetyChecklistActionCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistActionPost(body?: SafetyChecklistActionCommand, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistActionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} [toDoPage] 
     * @param {number} [overduePage] 
     * @param {number} [managePage] 
     * @param {number} [completedPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAdmindashboardGet(toDoPage?: number, overduePage?: number, managePage?: number, completedPage?: number, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAdmindashboardGet(toDoPage, overduePage, managePage, completedPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAllassetsGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAllassetsGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAssetGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAssetGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SafetyChecklistAttachmentDeleteCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAttachmentdeletePost(body?: SafetyChecklistAttachmentDeleteCommand, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAttachmentdeletePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAttachmentsGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAttachmentsGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SafetyChecklistAttachmentUploadCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistAttachmentuploadPost(body?: SafetyChecklistAttachmentUploadCommand, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistAttachmentuploadPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistChecklistGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistChecklistGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistCommentGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistCommentGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SafetyChecklistCommentCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistCommentPost(body?: SafetyChecklistCommentCommand, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistCommentPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [checklistId] 
     * @param {string} [checklistTemplateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistEditGet(checklistId?: string, checklistTemplateId?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistEditGet(checklistId, checklistTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SafetyChecklistSubmitCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistSubmitPost(body?: SafetyChecklistSubmitCommand, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistSubmitPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistSummarypdfassetGet(id?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistSummarypdfassetGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [templateId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistTemplateGet(templateId?: string, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistTemplateGet(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistTemplatesGet(options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} [toDoPage] 
     * @param {number} [overduePage] 
     * @param {number} [completedPage] 
     * @param {number} [managePage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyChecklistApi
     */
    public apiSafetychecklistUserdashboardGet(toDoPage?: number, overduePage?: number, completedPage?: number, managePage?: number, options?: any) {
        return SafetyChecklistApiFp(this.configuration).apiSafetychecklistUserdashboardGet(toDoPage, overduePage, completedPage, managePage, options).then((request) => request(this.axios, this.basePath));
    }
}
